import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { PureComponent } from 'react';
import { focusById } from '@scp/ui-shared/theme/utils';

var getValidIndex = function getValidIndex(ids, index) {
  if (index < 0) return ids.length - 1;
  if (index >= ids.length) return 0;
  return index;
};

var getIdByIndex = function getIdByIndex(ids, index) {
  return ids[index];
};
/**
 * This component should be used as a base for lists that use arrow navigation
 * (arrow key up or arrow key down).
 *
 * You must provide an array of IDs that will be rendered in the list.
 *
 * Switching between values is based by index.
 * You can pass `defaultFocusedIndex` if you want to change default focused item.
 */


export var ArrowNavigationBase = /*#__PURE__*/function (_PureComponent) {
  _inherits(ArrowNavigationBase, _PureComponent);

  var _super = _createSuper(ArrowNavigationBase);

  function ArrowNavigationBase() {
    var _this;

    _classCallCheck(this, ArrowNavigationBase);

    _this = _super.apply(this, arguments);
    _this.focusedIndex = _this.defaultFocusedIndex;

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          _this$props$ids = _this$props.ids,
          ids = _this$props$ids === void 0 ? [] : _this$props$ids,
          allowHorizontalArrows = _this$props.allowHorizontalArrows;
      if (!ids.length) return;

      if (e.key === 'ArrowUp' || allowHorizontalArrows && e.key === 'ArrowLeft') {
        e.preventDefault();

        _this.focusByIndex(getValidIndex(ids, _this.focusedIndex - 1));

        return;
      }

      if (e.key === 'ArrowDown' || allowHorizontalArrows && e.key === 'ArrowRight') {
        e.preventDefault();

        _this.focusByIndex(getValidIndex(ids, _this.focusedIndex + 1));
      }
    };

    return _this;
  }

  _createClass(ArrowNavigationBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) this.focusByIndex(this.focusedIndex);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.children !== prevProps.children) {
        // Reset focused element, if the children has changed
        this.focusedIndex = this.defaultFocusedIndex;
      }
    }
  }, {
    key: "focusByIndex",
    value: function focusByIndex(newIndex) {
      var _this$props$ids2 = this.props.ids,
          ids = _this$props$ids2 === void 0 ? [] : _this$props$ids2;
      var id = getIdByIndex(ids, newIndex);

      if (id) {
        focusById(id);
        this.focusedIndex = newIndex;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          ids = _a.ids,
          defaultFocusedIndex = _a.defaultFocusedIndex,
          children = _a.children,
          autoFocus = _a.autoFocus,
          allowHorizontalArrows = _a.allowHorizontalArrows,
          otherProps = __rest(_a, ["ids", "defaultFocusedIndex", "children", "autoFocus", "allowHorizontalArrows"]);

      return React.createElement("div", Object.assign({
        onKeyDown: this.handleKeyDown
      }, otherProps), children);
    }
  }, {
    key: "defaultFocusedIndex",
    get: function get() {
      var _this$props2 = this.props,
          defaultFocusedIndex = _this$props2.defaultFocusedIndex,
          _this$props2$ids = _this$props2.ids,
          ids = _this$props2$ids === void 0 ? [] : _this$props2$ids,
          autoFocus = _this$props2.autoFocus;
      if (!defaultFocusedIndex && defaultFocusedIndex !== 0) return autoFocus ? 0 : -1;
      return getValidIndex(ids, defaultFocusedIndex);
    }
  }]);

  return ArrowNavigationBase;
}(PureComponent);
ArrowNavigationBase.defaultProps = {
  ids: [],
  defaultFocusedIndex: null,
  autoFocus: false,
  children: null,
  allowHorizontalArrows: false
};